import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import type { LicensedFeature } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { useLocation } from "react-router-dom";
import InternalRedirect from "~/components/Navigation/InternalRedirect/InternalRedirect";
import { SkeletonLoadingLayout } from "~/components/SkeletonLoadingLayout/SkeletonLoadingLayout";
const ALLOWED_LICENSES_FEATURES: LicensedFeature[] = ["ProcessTemplates", "Policies"];
export function PlatformHubLicenseRedirect({ children }: {
    children?: React.ReactNode;
}) {
    const location = useLocation();
    const { result: licenseCheck, isLoading } = useInlineStatusQuery((repository) => repository.Licenses.getFeatures(), [], "CheckPlatformHubLicense");
    if (location.pathname.includes("/unlicensed")) {
        return <>{children}</>;
    }
    if (!licenseCheck || isLoading) {
        return <SkeletonLoadingLayout errors={undefined}/>;
    }
    if (!licenseCheck.EnabledFeatures.some((x) => ALLOWED_LICENSES_FEATURES.includes(x))) {
        return <InternalRedirect to={links.platformHubUpsellPage.generateUrl()}/>;
    }
    return <>{children}</>;
}
